import ApiService from "../ApiService";

export default class RegionService {
  static getRegionByParent = async (parent) => {
    const instance = await ApiService();
    return instance.get(`/region?parent=${parent}`);
  };
}
